import React, { useState, useEffect, useContext } from "react";
import {
    Dialog, DialogTitle, DialogContent, Button, Typography,
    DialogActions, IconButton, Grid, Tooltip, TextField,
    MenuItem, Box, Card, CardContent
}
    from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { DataGrid, esES, GridActionsCellItem } from '@mui/x-data-grid';
import { Flex } from "@chakra-ui/layout";
import DeleteIcon from '@mui/icons-material/Delete';
import ModalGuiasEntregar from "./ModalGuiasEntregar";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../app/store/root";
import { toJS } from "mobx";
import { EnumCatalogosEncabezado, EnumStatusShipmentString, EnumStatusEmbarqueString, EnumCatalogoEstatusString } from "../../shared/Enumerables";
import { ModalComponent } from "../../app/common/ModalComponent";
import { getColorEstatusEmbarque, getFormatDate } from "../../app/util/util";
import { Acciones } from "../../app/util/permisos"
import { account } from '../../shared/Utils';
import DialogComponent from "../../app/common/DialogComponent";
import { blobToBase64 } from "../../app/util/util";

const ModalActualizarEstatus = ({ onClose, onFinish, modelEditar }) => {

    const [permisosUsuario, setPermisosUsuario] = React.useState([])
    const rootStore = useContext(RootStoreContext);

    const {
        actualizarEstatusEmbarque: _actualizarEstatusEmbarque,
        consultarComprobanteArchivoFile: _consultarComprobanteArchivoFile
    } = rootStore.embarqueStore

    const {
        getValoresCatalogo,
    } = rootStore.catalogosStore

    const [urlBlob, setUrlBlob] = useState(undefined);
    const [pageSize, setPageSize] = React.useState(5);

    const [enviosEmbarque, setEnviosEmbarque] = useState([])
    const [estatusStore, setEstatusStore] = useState([])
    const [bloquearFormulario, setBloquearFormulario] = useState(false)
    const [estatusEnvioStore, setEstatusEnvioStore] = useState([])
    const [idEmbarque, setIdEmbarque] = useState(null)
    const [showConfirmEliminarArchivo, setShowConfirmEliminarArchivo] = useState(false)
    const [showConfirmClickEliminarArchivo, setShowConfirmClickEliminarArchivo] = useState(false)

    const [modelEmbarque, setModelEmbarque] = useState({
        EstatusAnterior: null,
        IdEstatusAnterior: null,
        FechaEstatus: null,
        IdEstatus: null,
        Estatus: null,
        Comentarios: null,
        NombreArchivo: null,
        ArchivoAdjunto: null,
        IdEnvios: []
    })

    const [movimientoEmbarque, setMovimientoEmbarque] = useState([])
    const [errors, setErrors] = useState({
        IdEstatus: null,
    })
    const [messages, setMessages] = useState({
        IdEstatus: ''
    })

    const setError = (key, value) => {
        setErrors({ ...errors, ...{ [key]: value } });
    }
    const setMessage = (key, value) => {
        setMessages({ ...messages, ...{ [key]: value } });
    }
    const setValue = (key, value) => {
        setModelEmbarque({ ...modelEmbarque, ...{ [key]: value } });
    }

    useEffect(() => {
        loadDataPage()
        setPermisosUsuario(account.getPermisosUsuario())
        if (modelEditar != null) {
            var model = toJS(modelEditar)
            setIdEmbarque(model.idEmbarque)
            setModelEmbarque({
                EstatusAnterior: model.estatus,
                IdEstatusAnterior: model.idEstatus,
                FechaEstatus: model.fechaUltimoEstatus,
                IdEstatus: null,
                Estatus: null,
                Comentarios: null,
                NombreArchivo: null,
                ArchivoAdjunto: null,
                IdEnvios: []
            })
            setMovimientoEmbarque(model.movimientos.map(a => {
                return {
                    idMovimientoEmbarque: a.idMovimientoEmbarque,
                    idEstatus: a.idEstatus,
                    estatus: a.estatus,
                    fechaMovimiento: a.fechaMovimiento,
                    comentarios: a.comentarios,
                    eliminar: false
                }
            }))
            setErrors({
                IdEstatus: false
            })            
            if (model.estatus?.toUpperCase() == EnumStatusEmbarqueString.Entregado) {
                consultarComprobanteArchivoFile(model.idEmbarque)
            }
        }
    }, [])

    const consultarComprobanteArchivoFile = async (idEmbarque) => {        
        let pdf = await _consultarComprobanteArchivoFile(idEmbarque)
        if (pdf != null) {
            const pdfBase64 = await blobToBase64(pdf.data)
            setUrlBlob(pdfBase64);
        }
    }

    const loadDataPage = async () => {
        let estatus = await getValoresCatalogo(EnumCatalogosEncabezado.EstatusEmbarque)
        if (estatus != null) {
            let estatusValidos = [EnumStatusEmbarqueString.Creado, EnumStatusEmbarqueString.En_Transito, EnumStatusEmbarqueString.Entregado]
            setEstatusStore(estatus.filter(a => estatusValidos.includes(a.valor.toUpperCase())).map(a => { return { id: a.id, valor: a.valor } }))
        }
        var model = toJS(modelEditar)
        let estatusEnvio = await getValoresCatalogo(EnumCatalogosEncabezado.EstatusEnvios)
        if (estatusEnvio != null) {
            setEstatusEnvioStore(estatusEnvio)
            setEnviosEmbarque(model.envios.map(a => { return { ...a, estatus: estatusEnvio.find(b => b.id == a.idEstatus)?.valor ?? '' } }))
        } else {
            setEnviosEmbarque(model.envios.map(a => { return { ...a, estatus: '' } }))
        }
    }

    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleClose = () => {
        setAnchorEl(null);
    }

    const [tempEstatus, setTempEstatus] = useState(null)
    const cambioEstatus = (value) => {
        if (!value) {
            setModelEmbarque({
                EstatusAnterior: modelEmbarque.EstatusAnterior,
                IdEstatusAnterior: modelEmbarque.IdEstatusAnterior,
                FechaEstatus: modelEmbarque.FechaEstatus,
                IdEstatus: null,
                Estatus: null,
                Comentarios: modelEmbarque.Comentarios,
                NombreArchivo: null,
                ArchivoAdjunto: null,
                IdEnvios: []
            });
            setUrlBlob(null);
            document.getElementById('file').value = []
            return
        }
        //obtener nuevo estatus seleccionado 
        var nuevoEstatus = (estatusStore.find(a => a.id == value)?.valor ?? "").toUpperCase()

        //validar el cambio de estatus que no salte de estatus
        if (modelEmbarque.EstatusAnterior.toUpperCase() == EnumStatusEmbarqueString.Creado && nuevoEstatus == EnumStatusEmbarqueString.Entregado
            || modelEmbarque.EstatusAnterior.toUpperCase() == EnumStatusEmbarqueString.Entregado && nuevoEstatus == EnumStatusEmbarqueString.Creado) {
            rootStore.alertStore.alertError(`No se permite pasar de estatus ${modelEmbarque.EstatusAnterior.toLowerCase()} a ${nuevoEstatus.toLowerCase()}.`)
            return
        }

        //validar el cambio de estatus hacia atras por permiso.
        if ((modelEmbarque.EstatusAnterior.toUpperCase() == EnumStatusEmbarqueString.En_Transito && nuevoEstatus == EnumStatusEmbarqueString.Creado
            || modelEmbarque.EstatusAnterior.toUpperCase() == EnumStatusEmbarqueString.Entregado && nuevoEstatus == EnumStatusEmbarqueString.En_Transito)
            && !permisosUsuario.some(a => a.clavePermiso === Acciones.Retroceder_estatus_embarque && a.tienePermiso)) {
            rootStore.alertStore.alertError(`No tiene permiso para retroceder el estatus del embarque.`)
            return
        }

        //validar el retroceso de estatus Entregado, para que el usuario confirme eliminar el archivo
        if (modelEmbarque.EstatusAnterior.toUpperCase() == EnumStatusEmbarqueString.Entregado && nuevoEstatus == EnumStatusEmbarqueString.En_Transito) {
            //ventana de confirmacion de eliminar el archivo etc etc.... bug 52255            
            setTempEstatus(value)
            setShowConfirmEliminarArchivo(true)
            return
        }

        if (nuevoEstatus == EnumStatusEmbarqueString.Entregado &&
            !enviosEmbarque.some(a => a.estatus?.toUpperCase() !== EnumStatusShipmentString.Entregado)) {
            rootStore.alertStore.alertError('Todas las guías de este embarque ya fueron entregadas')
            return
        }

        if (nuevoEstatus == EnumStatusEmbarqueString.Entregado) {
            setOpenDialogGuias(true)
        }

        setModelEmbarque({
            EstatusAnterior: modelEmbarque.EstatusAnterior,
            IdEstatusAnterior: modelEmbarque.IdEstatusAnterior,
            FechaEstatus: modelEmbarque.FechaEstatus,
            IdEstatus: value,
            Estatus: estatusStore.find(a => a.id == value)?.valor ?? "",
            Comentarios: modelEmbarque.Comentarios,
            NombreArchivo: null,
            ArchivoAdjunto: null,
            IdEnvios: []
        });
        setUrlBlob(null);
        document.getElementById('file').value = []
    }

    const onAcceptEliminarArchivo = () => {
        setModelEmbarque({
            EstatusAnterior: modelEmbarque.EstatusAnterior,
            IdEstatusAnterior: modelEmbarque.IdEstatusAnterior,
            FechaEstatus: modelEmbarque.FechaEstatus,
            IdEstatus: tempEstatus,
            Estatus: estatusStore.find(a => a.id == tempEstatus)?.valor ?? "",
            Comentarios: modelEmbarque.Comentarios,
            NombreArchivo: null,
            ArchivoAdjunto: null,
            IdEnvios: []
        });
        setUrlBlob(null);
        document.getElementById('file').value = []
    }

    //DIALOG GUIAS ENTREGAR
    const [openGuias, setOpenDialogGuias] = React.useState(null)

    const openDialogGuias = () => {
        setOpenDialogGuias(true);
        handleClose();
    }

    const closeDialogGuias = () => {
        setOpenDialogGuias(null);
    }

    const onFinishSeleccionEnvios = (guias) => {        
        setValue("IdEnvios", guias)
        closeDialogGuias()
    }

    // TABLE
    const [rowDelete, setRowDelete] = useState(null)
    const [showConfirmEliminarMovimiento, setShowConfirmEliminarMovimiento] = React.useState(false)

    const onAcceptEliminar = () => {
        eliminarMovimiento()
    }

    const eliminarMovimiento = () => {
        const row = toJS(rowDelete.row);
        if (row && Object.keys(row).length > 0) {
            let movimientos = movimientoEmbarque.map(a => { return { ...a } })
            const index = movimientos.findIndex((x) => x.idMovimientoEmbarque === row.idMovimientoEmbarque);
            movimientos.splice(index, 1)
            setMovimientoEmbarque(movimientos)
            setBloquearFormulario(false)
        }
    };

    const columns = [
        {
            field: 'estatus',
            headerName: 'Estatus',
            headerClassName: 'tableHeaders',
            renderHeader: () => (
                <span className="headerTable">
                    Estatus
                </span>
            ),
        },
        {
            field: 'fechaMovimiento',
            headerName: 'Fecha',
            headerClassName: 'tableHeaders',
            renderCell: (row) => (
                getFormatDate(row.row.fechaMovimiento)
            ),
            renderHeader: () => (
                <span className="headerTable">
                    Fecha
                </span>
            ),
        },
        {
            field: 'comentarios',
            headerName: 'Detalles de la actualización',
            minWidth: 150,
            flex: 1,
            headerClassName: 'tableHeaders',
            renderHeader: () => (
                <span className="headerTable">
                    Detalles de la actualización
                </span>
            ),
        },
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Acciones',
            headerClassName: 'tableHeaders',
            getActions: (params) => [
                <Tooltip title="Eliminar" placement="top" >
                    <GridActionsCellItem
                        hidden={!params.row.eliminar}
                        icon={<DeleteIcon />}
                        label="Eliminar"
                        color='primary.main'
                        onClick={() => {
                            setRowDelete(params)
                            setShowConfirmEliminarMovimiento(true)
                        }}
                    />
                </Tooltip >
            ],
        },
    ];

    const seleccionarArchivo = (e) => {
        e.preventDefault()
        let inputFile = document.getElementById('file')
        inputFile.click()
    }

    const changeHandler = async (event) => {
        if (event?.target?.files?.length > 0) {
            if(event.target.files[0].type !=  "application/pdf"){
                rootStore.alertStore.alertError("El formato del archivo debe ser pdf")
                document.getElementById('file').value = []
                return
            }
            var base64File = await getBase64(event.target.files[0])
            if (base64File != null) {
                setModelEmbarque({
                    EstatusAnterior: modelEmbarque.EstatusAnterior,
                    IdEstatusAnterior: modelEmbarque.IdEstatusAnterior,
                    FechaEstatus: modelEmbarque.FechaEstatus,
                    IdEstatus: modelEmbarque.IdEstatus,
                    Estatus: modelEmbarque.Estatus,
                    Comentarios: modelEmbarque.Comentarios,
                    NombreArchivo: event.target.files[0].name,
                    ArchivoAdjunto: base64File.split(',')[1],
                    IdEnvios: modelEmbarque.IdEnvios
                });
                setUrlBlob(base64File);
            }
        }
    }

    const getBase64 = (file) => {
        return new Promise(resolve => {
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                resolve(reader.result)
            };
            reader.onerror = function (error) {
                resolve(null)
            };
        })
    }

    const eliminarArchivo = () => {        
        setModelEmbarque({
            EstatusAnterior: modelEmbarque.EstatusAnterior,
            IdEstatusAnterior: modelEmbarque.IdEstatusAnterior,
            FechaEstatus: modelEmbarque.FechaEstatus,
            IdEstatus: modelEmbarque.IdEstatus,
            Estatus: modelEmbarque.Estatus,
            Comentarios: modelEmbarque.Comentarios,
            NombreArchivo: null,
            ArchivoAdjunto: null,
            IdEnvios: modelEmbarque.IdEnvios
        });
        setUrlBlob(null)
        document.getElementById('file').value = []
    }

    //Agregar Movimiento de Estatus Embarque
    const actualizarEstatus = (event) => {
        event.preventDefault()
        //obtener nuevo estatus seleccionado 
        var nuevoEstatus = (estatusStore.find(a => a.id == modelEmbarque.IdEstatus)?.valor ?? "").toUpperCase()
        //validar el cambio de estatus hacia atras por permiso.
        if (modelEmbarque.EstatusAnterior.toUpperCase() == EnumStatusEmbarqueString.Creado && nuevoEstatus == EnumStatusEmbarqueString.Entregado
            || modelEmbarque.EstatusAnterior.toUpperCase() == EnumStatusEmbarqueString.Entregado && nuevoEstatus == EnumStatusEmbarqueString.Creado) {
            rootStore.alertStore.alertError(`No se permite pasar de estatus ${modelEmbarque.EstatusAnterior} a ${nuevoEstatus}.`)
            return
        }
        //validar el cambio de estatus que no salte de estatus
        if ((modelEmbarque.EstatusAnterior.toUpperCase() == EnumStatusEmbarqueString.En_Transito && nuevoEstatus == EnumStatusEmbarqueString.Creado
            || modelEmbarque.EstatusAnterior.toUpperCase() == EnumStatusEmbarqueString.Entregado && nuevoEstatus == EnumStatusEmbarqueString.En_Transito)
            && !permisosUsuario.some(a => a.clavePermiso === Acciones.Retroceder_estatus_embarque && a.tienePermiso)) {
            rootStore.alertStore.alertError(`No tiene permiso para retroceder el estatus del embarque.`)
            return
        }

        if (nuevoEstatus == EnumStatusEmbarqueString.Entregado &&
            !enviosEmbarque.some(a => a.estatus?.toUpperCase() !== EnumStatusShipmentString.Entregado)) {
            rootStore.alertStore.alertError('Ya no existen guias en el embarque por entregar.')
            return
        }

        let movimientos = movimientoEmbarque.map(a => { return { ...a } })
        movimientos.push({
            idMovimientoEmbarque: 'eliminar',
            idEstatus: modelEmbarque.IdEstatus,
            estatus: modelEmbarque.Estatus,
            fechaMovimiento: new Date(),
            comentarios: modelEmbarque.Comentarios,
            eliminar: true
        })
        setMovimientoEmbarque(movimientos)
        setBloquearFormulario(true)
    }

    const actualizarEstatusEmbarque = async () => {
        rootStore.logisticBackdropStore.openLoading()
        let resp = await _actualizarEstatusEmbarque(idEmbarque, modelEmbarque);
        if (!resp.success) {
            rootStore.logisticBackdropStore.closeLoading()
            rootStore.alertStore.alertError(resp.responseMessage)
            return
        }
        rootStore.alertStore.alertSuccess("Embarque actualizado exitosamente.")
        rootStore.logisticBackdropStore.closeLoading()
        onFinish(true)
    }

    const [showConfirmCancel, setShowConfirmCancel] = React.useState(false)
    const onAccept = () => {
        onClose()
    }
    const [showConfirmGuardar, setShowConfirmGuardar] = React.useState(false)
    return (
        <>
            <DialogTitle>
                Actualización de estatus del embarque
                <IconButton aria-label="close"
                    onClick={(e) => setShowConfirmCancel(true)}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Box noValidate
                    component="form"
                    sx={{
                        display: 'flex',
                        m: 'auto',
                        width: '100%',
                        flexDirection: 'column',
                        marginBottom: '10px'
                    }}>

                    <Grid container columnSpacing={2} direction="row" justifyContent={"space-between"} mb={1}>
                        <Grid item lg={2} md={3} sm={6} xs={6}>
                            <Flex direction={"column"}>
                                <Typography variant="h6">
                                    Estatus actual
                                </Typography>
                                <Typography variant="estatus" color={getColorEstatusEmbarque(modelEmbarque.EstatusAnterior ?? '') + '.main'}>{modelEmbarque.EstatusAnterior}</Typography>
                                <Typography variant="subtitle">{getFormatDate(modelEmbarque.FechaEstatus)}</Typography>
                            </Flex>
                        </Grid>

                        <Grid item lg={4} md={3} sm={6} xs={6}>
                            <TextField
                                size="small"
                                margin="normal"
                                select
                                required
                                fullWidth
                                id="selectEstatus"
                                value={modelEmbarque.IdEstatus}
                                label="Estatus"
                                error={errors.IdEstatus}
                                helperText={messages.IdEstatus}
                                disabled={bloquearFormulario}
                                onChange={(e) => {
                                    e.preventDefault()
                                    cambioEstatus(e.target.value)
                                    setError("IdEstatus", !e.target.value)
                                    setMessage("IdEstatus",
                                        !e.target.value ? "Seleccione un estatus" : ""
                                    );
                                }}
                            >
                                <MenuItem value={null} name={null}><em>Seleccionar</em></MenuItem>
                                {estatusStore.map((estatus) => (
                                    <MenuItem id={estatus.id} value={estatus.id} name={estatus.valor}>{estatus.valor}</MenuItem>
                                ))}
                            </TextField>
                        </Grid>

                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <TextField
                                margin="normal"
                                fullWidth
                                id="detallesActualización"
                                label="Detalles de la actualización del embarque"
                                placeholder="Ingrese algún comentario, observación o detalle del embarque"
                                name="detallesActualización"
                                multiline
                                rows={4}
                                disabled={bloquearFormulario}
                                onChange={(e) => {
                                    setValue("Comentarios", e.target.value)
                                }}
                                value={modelEmbarque.Comentarios || ""}
                            />
                        </Grid>
                    </Grid>

                    <Grid container direction={'column'} spacing={1} mb={2}>
                        <Grid item container direction={'row'} spacing={1} mb={1} justifyContent="end" alignItems={"center"}>
                            <Grid item>
                                <Button variant="contained" disabled={modelEmbarque.Estatus?.toUpperCase() != EnumStatusEmbarqueString.Entregado || bloquearFormulario}
                                    onClick={(e) => seleccionarArchivo(e)}>Cargar comprobante</Button>
                                <input id="file" hidden={true} type="file" name="file" accept="application/pdf" onChange={(event) => { changeHandler(event) }} />
                            </Grid>
                            <Grid item>
                                <Button variant="contained" disabled={!(modelEmbarque.Estatus?.toUpperCase() == EnumStatusEmbarqueString.Entregado && modelEmbarque.ArchivoAdjunto?.length > 10) || bloquearFormulario}
                                    onClick={(e) => setShowConfirmClickEliminarArchivo(true)}>Eliminar comprobante</Button>
                            </Grid>
                        </Grid>
                        <Grid item sm={12}>
                            <Card className="card" sx={{ width: '100%', height: 300 }}>
                                <CardContent>
                                    {/*<Typography color='primary' variant='h5'>
                                        Archivo Cargado
                            </Typography>*/}
                                    <Box sx={{ width: "100%", height: 500 }}>
                                        <embed
                                            src={urlBlob}
                                            type="application/pdf"
                                            width="100%"
                                            height="600px"
                                        />
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>

                    <Grid container direction={'row'} justifyContent="end" alignItems={"center"}>
                        <Grid item>
                            <Button
                                disabled={!((modelEmbarque.Estatus?.toUpperCase() != EnumStatusEmbarqueString.Entregado && modelEmbarque.IdEstatus != null)
                                    || (modelEmbarque.Estatus?.toUpperCase() == EnumStatusEmbarqueString.Entregado && modelEmbarque.ArchivoAdjunto?.length > 10))
                                    || bloquearFormulario}
                                variant="contained" onClick={(event) => actualizarEstatus(event)}>Actualizar</Button>
                        </Grid>
                    </Grid>
                </Box>

                <div className='mb-2 d-flex' >
                    <Typography color='primary' variant='h5'>
                        Actualizaciones
                    </Typography>
                </div>
                <Box sx={{
                    width: '100%',
                    '& .tableHeaders': {
                        color: 'primary.main',
                    },
                }}>

                    <DataGrid
                        localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                        getRowId={(row) => row.idMovimientoEmbarque}
                        autoHeight
                        rows={movimientoEmbarque}
                        columns={columns}
                        pageSize={pageSize}
                        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                        rowsPerPageOptions={[5, 10, 20]}
                        pagination
                    />
                </Box>
            </DialogContent>
            <DialogActions variant="paddi">
                <Button variant="contained" color="secondary" sx={{ color: '#fff' }} onClick={(e) => setShowConfirmCancel(true)} >
                    Cancelar
                </Button>
                <Button onClick={(event) => setShowConfirmGuardar(true)} variant="contained" disabled={!bloquearFormulario}>
                    Aceptar
                </Button>
            </DialogActions>
            <ModalComponent
                Open={openGuias}
                HandleClose={() => closeDialogGuias()}
                ClassName="modal-xl"
                Body={() => (
                    <ModalGuiasEntregar
                        onClose={() => { closeDialogGuias() }}
                        onFinish={(resp) => { onFinishSeleccionEnvios(resp) }}
                        guiasEmbarque={enviosEmbarque}
                    />
                )}
            />
            <DialogComponent
                Open={showConfirmGuardar}
                Message="¿Seguro que quiere guardar estos cambios?"
                OnClose={() => setShowConfirmGuardar(false)}
                OnAccept={() => {
                    setShowConfirmGuardar(false)
                    actualizarEstatusEmbarque()
                }}
            />
            <DialogComponent
                Open={showConfirmCancel}
                Message="¿Está seguro de que desea cerrar esta ventana?"
                OnClose={() => setShowConfirmCancel(false)}
                OnAccept={() => {
                    setShowConfirmCancel(false)
                    onAccept()
                }}
            />
            <DialogComponent
                Open={showConfirmEliminarMovimiento}
                Message="¿Seguro que desea eliminar esta actualización?"
                OnClose={() => setShowConfirmEliminarMovimiento(false)}
                OnAccept={() => {
                    setShowConfirmEliminarMovimiento(false)
                    onAcceptEliminar()
                }}
            />
            <DialogComponent
                Open={showConfirmEliminarArchivo}
                Message="Al cambiar el estatus de Entregado el comprobante cargado se eliminará, ¿Seguro que desea continuar?"
                OnClose={() => setShowConfirmEliminarArchivo(false)}
                OnAccept={() => {
                    setShowConfirmEliminarArchivo(false)
                    onAcceptEliminarArchivo()
                }}
            />
            <DialogComponent
                Open={showConfirmClickEliminarArchivo}
                Message="¿Esta seguro que desea eliminar el archivo cargado?"
                OnClose={() => setShowConfirmClickEliminarArchivo(false)}
                OnAccept={() => {
                    setShowConfirmClickEliminarArchivo(false)
                    eliminarArchivo()
                }}
            />
        </>
    );
}

export default observer(ModalActualizarEstatus);